// prettier-ignore
enum MutationType {
  resetFilter = "resetFilter",
}

export default MutationType;
